import { useCallback, useMemo } from 'react';
import useQuery from '@/react-query/common/hooks/useQuery';
import { QK_SHOWS_BY_GENRE_ID } from '@/config/query-keys';
import { formatChannel } from '@/helpers/common';
import getChannelsByGenreId from '@/helpers/api/channels/getChannelsByGenreId';

export const createShowsByGenreIdQueryKey = ({ id } = {}) => [QK_SHOWS_BY_GENRE_ID, { id }];

const useShowsByGenreId = ({ enabled = true, id } = {}) => {
  const fetchShows = useCallback(() => getChannelsByGenreId({ id }), [id]);

  const results = useQuery({
    queryKey: createShowsByGenreIdQueryKey({ id }),
    queryFn: fetchShows,
    enabled: enabled && !!id,
    staleTime: 1000 * 60 * 30 // 30 minutes
  });
  const { data } = results;

  const {
    json,
    notFound,
    status: statusCode
  } = data || {};

  const { nodes: shows } = json || {};

  const showsFormatted = useMemo(() => (shows || []).map((show) => formatChannel(show)), [shows]);

  return {
    ...results,
    notFound,
    statusCode,
    shows: showsFormatted
  };
};

export default useShowsByGenreId;